<section class="rounded-sheet bg-vw-surface px-4 pb-4 pt-3 ring-1 ring-inset ring-vw-line" data-test="guest-trial">
  <h2 class="font-display text-title-l text-vw-ink">{{ 'home.guest.title' | translate }}</h2>
  <p class="mt-2 text-body-s font-semibold text-vw-muted" id="guest-commune">{{ 'home.guest.commune' | translate }}</p>
  <vw-location-input class="mt-1 block" [value]="commune" [placeholder]="'home.guest.commune-placeholder' | translate"
    [isError]="state === 'unknown-commune'" [prefix]="pin" (suggestionSelected)="onCommune($event)"></vw-location-input>
  <ng-template #pin><vw-map-pin-icon class="h-5 w-5 text-vw-primary" aria-hidden="true"></vw-map-pin-icon></ng-template>
  <p class="mt-3 text-body-s font-semibold text-vw-muted">{{ 'home.guest.crops-label' | translate }}</p>
  <vw-choice-selector class="mt-1 block" variant="chips" [multiple]="true" [max]="maxCrops" [options]="crops" [value]="chosen"
    [ariaLabel]="'home.guest.crops-label' | translate" (valueChange)="onCrops($event)"></vw-choice-selector>
</section>

@switch (state) {
  @case ('ready') {
    <vw-day-message class="mt-2 block" [message]="message!" [actions]="false"></vw-day-message>
  }
  @case ('empty') {
    <p class="mt-3 px-1 text-body-s text-vw-body" data-test="guest-trial-empty">{{ 'home.guest.empty' | translate }}</p>
  }
  @case ('unknown-commune') {
    <p class="mt-3 px-1 text-body-s text-vw-danger" role="alert">{{ 'home.guest.error-commune' | translate }}</p>
  }
  @case ('busy') {
    <p class="mt-3 px-1 text-body-s text-vw-body" role="alert">{{ 'home.guest.error-busy' | translate }}</p>
  }
  @case ('error') {
    <p class="mt-3 px-1 text-body-s text-vw-body" role="alert">{{ 'home.guest.error' | translate }}</p>
  }
}
@if (state === 'ready' || state === 'empty') {
  <!-- Le message montré, on propose de le garder : jamais avant. -->
  <div class="mt-2 flex flex-col items-center gap-2">
    <button type="button" (click)="signup()" data-test="guest-trial-signup"
      class="min-h-btn w-full rounded-pill bg-vw-primary px-6 text-body font-semibold text-vw-on-color active:bg-vw-primary-pressed">
      {{ 'home.guest.cta' | translate }}
    </button>
    <p class="text-body-s text-vw-muted">{{ 'home.guest.promise' | translate }}</p>
  </div>
}
